// .u_videoplayer

$(document).ready(function (e) {
  var $videos = $('.u_videoplayer')
  $videos.each(function (i, video) {
    videoplayerInit($(video))
  })
})

function videoplayerInit ($video) {
  var $preloader = $video.find('.image')
  var $videoContainer = $video.find('.video')
  var videoCode = $video.attr('data-video-src')
  var provider = $video.attr('data-provider')
  var originUrl = window.location.protocol + '//' + window.location.host
  $video.on('click', function () {
    $preloader.hide()
    // Create the iframe
    if (provider === 'youtube') {
      var $videoIframe = $('<iframe class="youtube-video" src="https://www.youtube.com/embed/' + videoCode + '?rel=0&autoplay=1&showinfo=0&enablejsapi=1&origin=' + originUrl + '" frameborder="0" allowfullscreen></iframe>')
      $videoContainer.append($videoIframe)
      $videoContainer.fitVids()
    } else if (provider === 'vimeo') {
      var $videoIframe = $('<iframe class="vimeo-video" src="https://player.vimeo.com/video/' + videoCode + '?autoplay=1&color=d91e29&title=0&byline=0&portrait=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
      $videoContainer.append($videoIframe)
      $videoContainer.fitVids()
    }
  })
}
